module.exports = __webpack_public_path__ + "src/assets/textures/env/woodboard/Wood_board_2k_bake.png";